module.exports = __webpack_public_path__ + "img/mansi.b90202ea.webp";